interface TriangleProps {
  fill?: string;
}
export function Triangle({ fill }: TriangleProps): React.JSX.Element {
  return (
    <svg
      fill="none"
      height="163"
      viewBox="0 0 207 163"
      width="207"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 163H206.5V0L0 163Z" fill={fill || "#f5f5f5"} />
    </svg>
  );
}
